var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPriorAuthorization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 13,
    viewBox: "0 0 18 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.281 0.969059C17.3508 1.03873 17.4062 1.12149 17.444 1.21261C17.4818 1.30373 17.5013 1.40141 17.5013 1.50006C17.5013 1.59871 17.4818 1.69639 17.444 1.78751C17.4062 1.87863 17.3508 1.96139 17.281 2.03106L6.78097 12.5311C6.7113 12.6009 6.62854 12.6563 6.53742 12.6941C6.4463 12.7319 6.34862 12.7514 6.24997 12.7514C6.15132 12.7514 6.05364 12.7319 5.96252 12.6941C5.8714 12.6563 5.78864 12.6009 5.71897 12.5311L0.468971 7.28106C0.328141 7.14023 0.249023 6.94922 0.249023 6.75006C0.249023 6.5509 0.328141 6.35989 0.468971 6.21906C0.609801 6.07823 0.800807 5.99911 0.999971 5.99911C1.19913 5.99911 1.39014 6.07823 1.53097 6.21906L6.24997 10.9396L16.219 0.969059C16.2886 0.899214 16.3714 0.8438 16.4625 0.80599C16.5536 0.768181 16.6513 0.748718 16.75 0.748718C16.8486 0.748718 16.9463 0.768181 17.0374 0.80599C17.1285 0.8438 17.2113 0.899214 17.281 0.969059Z",
    fill: "#6C757D"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriorAuthorization);
export default __webpack_public_path__ + "static/media/prior-authorization.46029885a5175c3d36712767d66fad11.svg";
export { ForwardRef as ReactComponent };